module.exports = __webpack_public_path__ + "img/eyyb-s1.8585b435.jpg";